export function Pagina(
  number = 0,
  content = [],
  numberOfElements = 0,
  totalElements = 0,
  totalPages = 0,
  sort = null
) {
  this.number = number;
  this.numberOfElements = numberOfElements;
  this.totalElements = totalElements;
  this.content = content;
  this.totalPages = totalPages;
  this.sort = sort;
}

export function BuildPagina(novaPagina) {
  return new Pagina(
    novaPagina.number,
    novaPagina.content,
    novaPagina.numberOfElements,
    novaPagina.totalElements,
    novaPagina.totalPages,
    novaPagina.sort
  );
}
